// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import { Form } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import EntityEditForm from '_components/entity-edit-form/index.jsx'
import AssignDestinations from './assign-destinations'

import './styles.scss'

// The page's views, kept in the address as ?view= so a reload or a shared link
// opens the same one. Only the open view is drawn, so the destinations list is
// fetched afresh each time it's opened, after an assignment too
const VIEWS = ['Metadata', 'Destinations', 'Assign']

// A salesforce integration partner, the destinations assigned to it, and a way to
// assign it to destinations by name. Whoever can edit destinations can edit partners
const SalesforceIntegrationPartnerPage = (props) => {
  useRetractSidebar()

  const requested = new URLSearchParams(props.location?.search).get('view')
  const view = VIEWS.includes(requested) ? requested : VIEWS[0]
  const open = (name) => props.history.replace({ search: `?view=${name}` })

  return (
    <div id="salesforce-integration-partner-page">
      <EntityEditForm
        entities="salesforce-integration-partners"
        id={props.match.params.id}
        resource="Destinations"
      >
        {({ disabled, item, onChange, schema }) => (
          <div className="partner-page">
            <div className="view-tabs" role="tablist" aria-label={item.name}>
              <For each="name" of={VIEWS}>
                <button
                  key={name}
                  type="button"
                  role="tab"
                  aria-selected={view === name}
                  className={`view-tabs__tab ${view === name ? 'is-active' : ''}`}
                  onClick={() => open(name)}
                >
                  {name}
                </button>
              </For>
            </div>

            <Choose>
              <When condition={view === 'Metadata'}>
                <Form
                  item={item}
                  onChange={onChange}
                  schema={schema}
                  fields={[{ name: 'name' }]}
                  disabled={disabled}
                />
              </When>

              <When condition={view === 'Destinations'}>
                <ListView
                  columns={[
                    {
                      key: 'name',
                      link: '/destinations/:_id',
                      name: 'Name',
                      sortable: true,
                    },
                    {
                      key: 'slug',
                      link: '/destinations/:_id',
                      name: 'Slug',
                      sortable: true,
                    },
                  ]}
                  qs={{ 'salesforce_integration_partner._id': item._id }}
                  entities="destinations"
                  fields={['name', 'slug']}
                  searchable={true}
                  sort_key={'name'}
                  sort_dir={1}
                  stateful={false}
                />
              </When>

              <Otherwise>
                <AssignDestinations partner={item} />
              </Otherwise>
            </Choose>
          </div>
        )}
      </EntityEditForm>
    </div>
  )
}

export default SalesforceIntegrationPartnerPage
